/* generated using openapi-typescript-codegen -- do not edit */

/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
import type { ModelSchema } from "./ModelSchema"
import type { ModelSettingsSet } from "./ModelSettingsSet"

/**
 * The serializer used for retrieving a Model.
 * In case it's needed in a creation view, change the fields properties (read_only, required etc.) and
 * the missing fields as needed.
 */
export type Model = {
  uuid: string
  project: string
  organization: string
  created_by: string
  created_at: string
  name: string
  /**
   * * `custom` - Custom
   * * `prebuilt` - Prebuilt
   * * `automl` - AutoML
   */
  readonly type: Model.type
  /**
   * * `live` - live
   * * `challenger` - challenger
   * * `disabled` - disabled
   * * `pending-action` - pending-action
   */
  state: Model.state
  image_url: string
  exposed_port: number
  is_ml_service_created: boolean
  /**
   * * `kcr` - kcr
   * * `private registry` - private registry
   * * `dockerhub` - dockerhub
   */
  container_registry: Model.container_registry
  registry_url: string
  image_name: string
  image_tag: string
  training_data?: string
  threshold_metrics?: string
  metrics?: string
  readonly schema: ModelSchema
  readonly active_settings_set: ModelSettingsSet | null
  /**
   * * `add-features-to-project-schema` - Add Features to project schema
   * * `fix-model-schema` - Fix Model Schema
   */
  pending_action: Model.pending_action
  automl_training_job: string | null
  retraining_job: string | null
}
export namespace Model {
  /**
   * * `custom` - Custom
   * * `prebuilt` - Prebuilt
   * * `automl` - AutoML
   */
  export enum type {
    CUSTOM = "custom",
    PREBUILT = "prebuilt",
    AUTOML = "automl",
  }
  /**
   * * `live` - live
   * * `challenger` - challenger
   * * `disabled` - disabled
   * * `pending-action` - pending-action
   */
  export enum state {
    LIVE = "live",
    CHALLENGER = "challenger",
    DISABLED = "disabled",
    PENDING_ACTION = "pending-action",
  }
  /**
   * * `kcr` - kcr
   * * `private registry` - private registry
   * * `dockerhub` - dockerhub
   */
  export enum container_registry {
    KCR = "kcr",
    PRIVATE_REGISTRY = "private registry",
    DOCKERHUB = "dockerhub",
  }
  /**
   * * `add-features-to-project-schema` - Add Features to project schema
   * * `fix-model-schema` - Fix Model Schema
   */
  export enum pending_action {
    ADD_FEATURES_TO_PROJECT_SCHEMA = "add-features-to-project-schema",
    FIX_MODEL_SCHEMA = "fix-model-schema",
  }
}
